import { Injectable } from '@angular/core';
import { fetchAndActivate, getValue, isSupported } from 'firebase/remote-config';
import { remoteConfig } from '../firebase/firebase';

@Injectable({
  providedIn: 'root',
})
export class RemoteConfigService {
  async init() {
    const supported = await isSupported();
    console.log('[Remote Config] isSupported:', supported);

    if (!supported) return;

    const fetched = await fetchAndActivate(remoteConfig);
    console.log('[Remote Config] fetchAndActivate result (true = new data fetched):', fetched);
    console.log(
      '[Remote Config] raw maintenance_mode value:',
      getValue(remoteConfig, 'maintenance_mode'),
    );
  }

  getBoolean(key: string): boolean {
    return getValue(remoteConfig, key).asBoolean();
  }

  getString(key: string): string {
    return getValue(remoteConfig, key).asString();
  }
}
